// Pass 59: month and date-range helpers shared by the Analytics pages.

export function monthLabel(ym) {
  const [y, m] = ym.split("-").map(Number);
  return new Date(y, m - 1, 1).toLocaleDateString("en-GB", { month: "long", year: "numeric" });
}

export function monthShort(ym) {
  const [y, m] = ym.split("-").map(Number);
  return new Date(y, m - 1, 1).toLocaleDateString("en-GB", { month: "short", year: "numeric" });
}

export function monthRange(ym) {
  const [y, m] = ym.split("-").map(Number);
  const lastDay = new Date(y, m, 0).getDate();
  return { from: `${ym}-01`, to: `${ym}-${String(lastDay).padStart(2, "0")}` };
}

// Which month (if any) a range exactly covers, so a picker can show
// "Custom range" instead of a month the range does not match.
export function matchingMonth(range) {
  if (!range?.from || !range?.to) return "";
  const ym = range.from.slice(0, 7);
  const full = monthRange(ym);
  return full.from === range.from && full.to === range.to ? ym : "";
}

// FastAPI validation errors (422) carry `detail` as a list of objects;
// React cannot render that, so flatten it to a sentence.
export function errText(e, fallback) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || String(x)).join(" ");
  return fallback;
}
